module.exports = __webpack_public_path__ + "static/img/UA.65bbce38.svg";